export const categories = [
  {
    slug: 'dianshiju',
    name: '电视剧',
    icon: 'ri-tv-line',
    description: '热门国产剧、韩剧、美剧、日剧等各类电视剧资源，高清全集免费在线观看',
  },
  {
    slug: 'dianying',
    name: '电影',
    icon: 'ri-film-line',
    description: '最新院线大片、经典老片、高分电影推荐，高清画质不缓冲畅快观看',
  },
  {
    slug: 'dongman',
    name: '动漫',
    icon: 'ri-emotion-laugh-line',
    description: '日本动漫、国产动漫、欧美动画，热门番剧持续更新中',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    icon: 'ri-live-line',
    description: '热门综艺节目、脱口秀、真人秀，欢乐不断精彩不停',
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    icon: 'ri-earth-line',
    description: 'BBC、Discovery等顶级纪录片，自然、历史、科技题材一网打尽',
  },
  {
    slug: 'duanju',
    name: '短剧',
    icon: 'ri-smartphone-line',
    description: '热门短剧、微短剧，节奏紧凑不拖沓，碎片时间追剧首选',
  },
];

export const videos = [
  {
    id: 1,
    title: '繁花',
    category: 'dianshiju',
    coverImage: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20for%20Chinese%20drama%20Fan%20Hua%20Blossoms%20Shanghai%201990s%20nostalgic%20warm%20golden%20lighting%20elegant%20film%20aesthetic%20rich%20colors%20vintage%20charm&width=600&height=375&seq=video-cover-01&orientation=landscape',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20poster%20for%20Chinese%20drama%20Fan%20Hua%20Blossoms%20Shanghai%201990s%20epic%20warm%20golden%20lighting%20film%20aesthetic&width=1200&height=675&seq=video-cover-01-detail&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=Fan%20Hua%20Blossoms%20Shanghai%20Chinese%20drama%20poster%20thumbnail%20warm%20tones&width=200&height=200&seq=video-cover-01-thumb&orientation=squarish',
    description: '九十年代的上海，阿宝凭借改革开放的春风和自己的打拼，成为商界一颗耀眼的明星。黄河路上，人来人往，故事不断上演。',
    content: '《繁花》是一部以上海为背景的年代剧。故事发生在九十年代的上海，改革开放的春风吹遍神州大地，黄河路上人来人往，商界风云变幻。阿宝从一个普通的年轻人，凭借自己的聪明才智和不懈努力，在商海中摸爬滚打，最终成为一代传奇人物。剧中不仅有商场上的尔虞我诈，更有那个年代独特的人情冷暖。王家卫导演用他独特的镜头语言，为观众呈现了一个充满魅力的上海。',
    tags: ['国产剧', '年代剧', '商战', '王家卫'],
    views: 12580000,
    date: '2026-07-28',
    rating: 9.2,
    platform: '蜜桃视频',
  },
  {
    id: 2,
    title: '流浪地球3',
    category: 'dianying',
    coverImage: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20for%20sci%20fi%20movie%20Wandering%20Earth%203%20epic%20space%20earth%20engines%20dramatic%20lighting%20cool%20blue%20warm%20orange%20contrast%20film%20aesthetic&width=600&height=375&seq=video-cover-02&orientation=landscape',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Wandering%20Earth%203%20sci%20fi%20epic%20wide%20cinematic%20poster%20space%20earth%20engines%20dramatic%20lighting&width=1200&height=675&seq=video-cover-02-detail&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=Wandering%20Earth%203%20sci%20fi%20movie%20poster%20thumbnail%20space%20theme&width=200&height=200&seq=video-cover-02-thumb&orientation=squarish',
    description: '太阳急速老化，持续膨胀，人类面临前所未有的生存危机。地球联合政府决定实施移山计划，带着地球去流浪。',
    content: '《流浪地球3》延续了前作的宏大叙事。太阳正在急速老化，持续膨胀，一百年后太阳将吞没整个地球。为了应对这场前所未有的危机，地球联合政府决定实施移山计划——在地球表面建造上万座行星发动机，推动地球离开太阳系，前往4.2光年外的新家园。在这场跨越时空的伟大旅程中，人类将面临无数未知的挑战和考验。',
    tags: ['科幻', '国产大片', '灾难', '刘德华', '吴京'],
    views: 38900000,
    date: '2026-07-15',
    rating: 8.8,
    platform: '西瓜视频',
  },
  {
    id: 3,
    title: '鬼灭之刃 柱训练篇',
    category: 'dongman',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20poster%20for%20Demon%20Slayer%20Hashira%20Training%20Arc%20dynamic%20action%20vibrant%20colors%20Japanese%20animation%20style%20warm%20orange%20gradient&width=600&height=375&seq=video-cover-03&orientation=landscape',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20Hashira%20Training%20Arc%20anime%20wide%20cinematic%20poster%20dynamic%20action%20vibrant&width=1200&height=675&seq=video-cover-03-detail&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20anime%20poster%20thumbnail%20Hashira%20Training&width=200&height=200&seq=video-cover-03-thumb&orientation=squarish',
    description: '炭治郎与同伴们受邀参加柱训练，在各位柱的严格指导下，他们不断提升自己的实力，为最终的决战做准备。',
    content: '《鬼灭之刃 柱训练篇》承接上一季剧情，炭治郎、善逸、伊之助以及祢豆子受邀参加由各位柱主持的特别训练。在训练过程中，他们分别接受了水柱、炎柱、风柱等顶尖剑士的指导，每个人的实力都得到了质的飞跃。与此同时，鬼舞辻无惨的阴影也在不断逼近，一场决定人类命运的最终决战即将拉开帷幕。',
    tags: ['日本动漫', '热血', '战斗', '鬼灭之刃'],
    views: 8900000,
    date: '2026-07-20',
    rating: 9.5,
    platform: '樱桃视频',
  },
  {
    id: 4,
    title: '奔跑吧 第十二季',
    category: 'zongyi',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20Running%20Man%20poster%20fun%20energetic%20bright%20colors%20outdoor%20adventure%20cheerful%20atmosphere%20warm%20sunlight&width=600&height=375&seq=video-cover-04&orientation=landscape',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Running%20Man%20Chinese%20variety%20show%20wide%20poster%20fun%20energetic%20bright%20outdoor&width=1200&height=675&seq=video-cover-04-detail&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=Running%20Man%20variety%20show%20poster%20thumbnail%20fun&width=200&height=200&seq=video-cover-04-thumb&orientation=squarish',
    description: '新一季跑男团再次集结，全新游戏环节、爆笑挑战任务，欢乐不停歇，每期都有惊喜嘉宾加盟。',
    content: '《奔跑吧》第十二季重磅回归！本季节目在延续经典游戏环节的基础上，加入了更多创新元素。跑男团的成员们将前往全国各地，在充满挑战的任务中展现团队协作精神。每期节目都有重量级嘉宾加盟，带来意想不到的精彩表现和爆笑瞬间。无论是烧脑的解谜环节还是体力与智慧并重的户外挑战，都让观众大呼过瘾。',
    tags: ['综艺', '真人秀', '搞笑', '户外'],
    views: 15600000,
    date: '2026-07-25',
    rating: 8.5,
    platform: '蜜桃视频',
  },
  {
    id: 5,
    title: '地球脉动 第三季',
    category: 'jilupian',
    coverImage: 'https://readdy.ai/api/search-image?query=BBC%20Planet%20Earth%20documentary%20poster%20stunning%20nature%20wildlife%20landscape%20vibrant%20green%20forest%20mountain%20cinematic%20aerial%20view&width=600&height=375&seq=video-cover-05&orientation=landscape',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Planet%20Earth%20BBC%20documentary%20wide%20cinematic%20poster%20stunning%20nature%20wildlife&width=1200&height=675&seq=video-cover-05-detail&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=Planet%20Earth%20documentary%20poster%20thumbnail%20nature&width=200&height=200&seq=video-cover-05-thumb&orientation=squarish',
    description: 'BBC倾力打造的自然纪录片巨制，用前所未有的视角展现地球上最壮丽的自然奇观和野生动物生存故事。',
    content: '《地球脉动》第三季是BBC自然历史部历时五年打造的史诗级纪录片。从极地冰原到热带雨林，从深海峡谷到高山之巅，摄制组用最先进的拍摄技术记录下了地球上最令人叹为观止的自然奇观。每一集都聚焦不同的生态环境，讲述动物们为了生存而奋斗的感人故事。这部纪录片不仅是一场视觉盛宴，更是对地球生命多样性的深情礼赞。',
    tags: ['纪录片', 'BBC', '自然', '动物'],
    views: 6700000,
    date: '2026-07-10',
    rating: 9.8,
    platform: '西瓜视频',
  },
  {
    id: 6,
    title: '重生之都市仙尊',
    category: 'duanju',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20urban%20cultivation%20drama%20poster%20Rebirth%20of%20Urban%20Immortal%20mystical%20golden%20light%20modern%20city%20contrast%20warm%20magical&width=600&height=375&seq=video-cover-06&orientation=landscape',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Rebirth%20of%20Urban%20Immortal%20Chinese%20drama%20wide%20poster%20mystical%20golden%20city&width=1200&height=675&seq=video-cover-06-detail&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=Urban%20Immortal%20Chinese%20drama%20poster%20thumbnail%20mystical&width=200&height=200&seq=video-cover-06-thumb&orientation=squarish',
    description: '一代仙尊重生回到都市少年时代，凭借着前世的记忆和修为，在这个平凡的世界中掀起惊涛骇浪。',
    content: '《重生之都市仙尊》讲述了修仙界第一强者林天，在渡劫失败后重生回到高中时代的故事。带着前世千年的修炼记忆和战斗经验，他在这个平凡的都市中重新开始。从校园到商场，从地下世界到修仙界，林天一步步重建自己的势力，揭开前世渡劫失败的真相。每集15分钟的紧凑节奏让观众欲罢不能。',
    tags: ['短剧', '修仙', '都市', '重生'],
    views: 4500000,
    date: '2026-07-30',
    rating: 8.0,
    platform: '樱桃视频',
  },
  {
    id: 7,
    title: '长相思',
    category: 'dianshiju',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20fantasy%20drama%20Lost%20You%20Forever%20poster%20ethereal%20beauty%20traditional%20costume%20warm%20golden%20light%20romance&width=600&height=375&seq=video-cover-07&orientation=landscape',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Lost%20You%20Forever%20Chinese%20ancient%20drama%20wide%20poster%20ethereal%20romance%20warm&width=1200&height=675&seq=video-cover-07-detail&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=Lost%20You%20Forever%20drama%20poster%20thumbnail%20ancient%20romance&width=200&height=200&seq=video-cover-07-thumb&orientation=squarish',
    description: '上古时代，人神妖混居。皓翎国王姬玖瑶流落大荒百年，化名玟小六在清水镇行医，命运的齿轮开始转动。',
    content: '《长相思》改编自桐华同名小说。故事发生在上古时代，皓翎国王姬玖瑶（小夭）流落大荒百年，失去了身份和灵力，化名玟小六在清水镇悬壶济世。她与涂山璟、相柳、玱玹之间错综复杂的情感纠葛，以及背后隐藏的天下大势，构成了一部荡气回肠的史诗。精湛的演技、精美的服化道、感人的音乐，让这部剧成为年度现象级作品。',
    tags: ['国产剧', '古装', '爱情', '玄幻'],
    views: 20100000,
    date: '2026-07-18',
    rating: 9.0,
    platform: '蜜桃视频',
  },
  {
    id: 8,
    title: '消失的她',
    category: 'dianying',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20thriller%20movie%20Lost%20in%20the%20Stars%20poster%20dark%20moody%20suspenseful%20warm%20neon%20lights%20noir%20aesthetic&width=600&height=375&seq=video-cover-08&orientation=landscape',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Lost%20in%20the%20Stars%20thriller%20movie%20wide%20poster%20dark%20moody%20suspense&width=1200&height=675&seq=video-cover-08-detail&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=Lost%20in%20the%20Stars%20thriller%20movie%20poster%20thumbnail&width=200&height=200&seq=video-cover-08-thumb&orientation=squarish',
    description: '何非的妻子在海外旅行时神秘失踪，当他报案后，一个陌生女人出现在他面前，声称自己才是他的妻子。',
    content: '《消失的她》是一部扣人心弦的悬疑惊悚片。何非和妻子李木子去东南亚度假，谁知妻子离奇失踪。他疯狂寻找，报警求助，却等来了一个自称是他妻子的陌生女人。所有的证据都指向这个女人就是李木子，但何非坚信她不是。在真相与谎言的迷雾中，一场惊心动魄的心理博弈悄然展开。反转再反转的剧情让观众大呼意外。',
    tags: ['悬疑', '惊悚', '犯罪', '国产电影'],
    views: 28900000,
    date: '2026-07-05',
    rating: 8.6,
    platform: '西瓜视频',
  },
  {
    id: 9,
    title: '间谍过家家 第二季',
    category: 'dongman',
    coverImage: 'https://readdy.ai/api/search-image?query=Spy%20x%20Family%20anime%20poster%20season%202%20cute%20family%20comedy%20action%20warm%20colorful%20playful%20Japanese%20animation&width=600&height=375&seq=video-cover-09&orientation=landscape',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Spy%20x%20Family%20season%202%20anime%20wide%20poster%20cute%20family%20comedy%20colorful&width=1200&height=675&seq=video-cover-09-detail&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=Spy%20x%20Family%20anime%20poster%20thumbnail%20cute&width=200&height=200&seq=video-cover-09-thumb&orientation=squarish',
    description: '为了执行维护和平的秘密任务，最强间谍劳埃德组建了一个临时家庭，但这个家庭的每个成员都隐藏着自己的秘密。',
    content: '《间谍过家家》第二季继续讲述福杰一家的故事。表面上这是一个普通的家庭——父亲劳埃德是上班族，母亲约尔是公务员，女儿阿尼亚在上学。但实际上，劳埃德是西国最强间谍黄昏，约尔是代号睡美人的顶级杀手，阿尼亚则是拥有读心能力的超能力者。他们各自为了不同的目的组成了这个虚假的家庭，却在相处中产生了真实的羁绊。',
    tags: ['日本动漫', '喜剧', '间谍', '家庭'],
    views: 11200000,
    date: '2026-07-22',
    rating: 9.4,
    platform: '樱桃视频',
  },
  {
    id: 10,
    title: '向往的生活 第八季',
    category: 'zongyi',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20Back%20to%20Field%20poster%20peaceful%20countryside%20garden%20warm%20sunlight%20cozy%20wooden%20house%20green%20nature&width=600&height=375&seq=video-cover-10&orientation=landscape',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Back%20to%20Field%20variety%20show%20wide%20poster%20peaceful%20countryside%20cozy%20green&width=1200&height=675&seq=video-cover-10-detail&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=Back%20to%20Field%20variety%20show%20poster%20thumbnail%20countryside&width=200&height=200&seq=video-cover-10-thumb&orientation=squarish',
    description: '几位好友远离城市喧嚣，在乡间小院过着自给自足的田园生活，每期迎来不同嘉宾，分享美食与故事。',
    content: '《向往的生活》第八季来到了江南水乡的一处美丽小院。黄磊、何炅等老朋友再次聚首，在青山绿水间过着简单而充实的生活。自己种菜、下厨做饭、招待来访的朋友，每一期都充满了温馨和感动。嘉宾们放下明星光环，在田园中找到了久违的宁静与快乐。这档节目不仅展示了美好的田园生活，更传递了一种返璞归真的人生态度。',
    tags: ['综艺', '慢生活', '美食', '田园'],
    views: 9800000,
    date: '2026-07-27',
    rating: 8.3,
    platform: '蜜桃视频',
  },
  {
    id: 11,
    title: '蓝色星球 第三季',
    category: 'jilupian',
    coverImage: 'https://readdy.ai/api/search-image?query=BBC%20Blue%20Planet%20ocean%20documentary%20poster%20deep%20sea%20marine%20life%20stunning%20coral%20reef%20blue%20underwater%20cinematic&width=600&height=375&seq=video-cover-11&orientation=landscape',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Blue%20Planet%20BBC%20ocean%20documentary%20wide%20poster%20deep%20sea%20marine%20stunning&width=1200&height=675&seq=video-cover-11-detail&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=Blue%20Planet%20ocean%20documentary%20poster%20thumbnail%20marine&width=200&height=200&seq=video-cover-11-thumb&orientation=squarish',
    description: '深入海洋世界，探索从未被拍摄过的深海奇观，揭示海洋生物令人惊叹的生存智慧和美丽。',
    content: '《蓝色星球》第三季带领观众潜入地球最后的未知领域——深海。利用最新的潜水技术和超高清摄影设备，摄制组记录了从珊瑚礁到深海热泉、从极地冰下到赤道暖流的各种海洋生态系统。观众将看到发光的水母群、巨型的鲸鲨、灵巧的章鱼以及无数令人惊叹的海洋生物。这部纪录片不仅展示了海洋的壮美，也揭示了气候变化对海洋生态的深刻影响。',
    tags: ['纪录片', '海洋', 'BBC', '自然'],
    views: 5400000,
    date: '2026-07-12',
    rating: 9.7,
    platform: '西瓜视频',
  },
  {
    id: 12,
    title: '我在古代当驸马',
    category: 'duanju',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20time%20travel%20comedy%20drama%20poster%20ancient%20palace%20modern%20man%20funny%20contrast%20warm%20colorful&width=600&height=375&seq=video-cover-12&orientation=landscape',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Chinese%20time%20travel%20comedy%20drama%20wide%20poster%20ancient%20palace%20funny&width=1200&height=675&seq=video-cover-12-detail&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=Time%20travel%20Chinese%20comedy%20drama%20poster%20thumbnail%20ancient&width=200&height=200&seq=video-cover-12-thumb&orientation=squarish',
    description: '现代打工人意外穿越到古代成为驸马，凭借着现代思维和知识在古代朝堂和后宫中闯出一片天地。',
    content: '《我在古代当驸马》讲述了程序员张凡加班猝死后穿越到古代，发现自己成了当朝驸马的故事。作为一个现代人，他带着21世纪的知识和思维方式，在古代朝堂上提出了各种新颖的政策建议，在后宫中用现代心理学化解各种矛盾。然而，朝堂之上的权力斗争和皇室的秘密，让他陷入了前所未有的危机之中。每集12分钟，节奏飞快。',
    tags: ['短剧', '穿越', '古装', '喜剧'],
    views: 6200000,
    date: '2026-08-01',
    rating: 7.8,
    platform: '樱桃视频',
  },
  {
    id: 13,
    title: '大江大河3',
    category: 'dianshiju',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20Like%20a%20Flowing%20River%20poster%20reform%20and%20opening%20up%20era%20industrial%20warm%20vintage%20tones%20nostalgic&width=600&height=375&seq=video-cover-13&orientation=landscape',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Like%20a%20Flowing%20River%20Chinese%20drama%20wide%20poster%20industrial%20reform%20era&width=1200&height=675&seq=video-cover-13-detail&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=Like%20a%20Flowing%20River%20drama%20poster%20thumbnail%20industrial&width=200&height=200&seq=video-cover-13-thumb&orientation=squarish',
    description: '改革开放浪潮中，宋运辉、雷东宝、杨巡三个年轻人在各自领域拼搏奋斗，见证了中国经济的腾飞。',
    content: '《大江大河3》延续了前两季的时代叙事。九十年代末到新世纪初，中国正经历着深刻的变革。宋运辉在国企改革中面临着前所未有的挑战，雷东宝带领村民走上了共同富裕的道路，杨巡则在市场经济的浪潮中不断寻找新的商机。三个人的命运与国家的命运紧密相连，他们的奋斗故事就是这个时代最生动的注脚。',
    tags: ['国产剧', '年代剧', '改革开放', '励志'],
    views: 17800000,
    date: '2026-07-16',
    rating: 9.1,
    platform: '蜜桃视频',
  },
  {
    id: 14,
    title: '满江红2',
    category: 'dianying',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20movie%20Full%20River%20Red%20poster%20ancient%20China%20Song%20dynasty%20dramatic%20red%20and%20gold%20aesthetic&width=600&height=375&seq=video-cover-14&orientation=landscape',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Full%20River%20Red%20Chinese%20historical%20movie%20wide%20poster%20Song%20dynasty%20dramatic&width=1200&height=675&seq=video-cover-14-detail&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=Full%20River%20Red%20movie%20poster%20thumbnail%20historical&width=200&height=200&seq=video-cover-14-thumb&orientation=squarish',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一个小兵与亲兵营副统领被卷入了一场惊天阴谋之中。',
    content: '《满江红2》是张艺谋导演的又一力作。故事依然发生在南宋年间，秦桧权倾朝野，岳飞含冤而死。一个小兵偶然获得了一份关乎国家命运的密信，被卷入了朝廷内部的权力斗争。亲兵营副统领奉命追查此事，两人在阴谋与真相之间展开了惊心动魄的较量。影片将悬疑、喜剧、历史元素巧妙融合，既有紧张刺激的剧情，也有令人捧腹的桥段。',
    tags: ['古装', '悬疑', '喜剧', '张艺谋'],
    views: 31200000,
    date: '2026-07-08',
    rating: 8.9,
    platform: '西瓜视频',
  },
  {
    id: 15,
    title: '葬送的芙莉莲',
    category: 'dongman',
    coverImage: 'https://readdy.ai/api/search-image?query=Frieren%20Beyond%20Journeys%20End%20anime%20poster%20fantasy%20adventure%20emotional%20warm%20golden%20sunset%20magical%20atmosphere&width=600&height=375&seq=video-cover-15&orientation=landscape',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Frieren%20anime%20wide%20poster%20fantasy%20adventure%20emotional%20warm%20sunset&width=1200&height=675&seq=video-cover-15-detail&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=Frieren%20anime%20poster%20thumbnail%20fantasy&width=200&height=200&seq=video-cover-15-thumb&orientation=squarish',
    description: '勇者一行人打败魔王后，精灵魔法使芙莉莲开始了了解人类的旅程。生命短暂的人类在她漫长的生命中留下了深刻的印记。',
    content: '《葬送的芙莉莲》讲述了一个关于时间与情感的故事。精灵魔法使芙莉莲是勇者队伍中的一员，他们一起经历了十年的冒险，最终打败了魔王。对于寿命长达千年的精灵来说，十年只是弹指一挥间。但当勇者辛美尔年老去世时，芙莉莲才意识到自己对人类的了解少之又少。她踏上了重新认识人类、理解情感的旅程。这部作品以其细腻的情感刻画和深刻的主题打动了无数观众。',
    tags: ['日本动漫', '奇幻', '治愈', '冒险'],
    views: 7600000,
    date: '2026-07-19',
    rating: 9.6,
    platform: '樱桃视频',
  },
  {
    id: 16,
    title: '我们的美好生活',
    category: 'zongyi',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20Our%20Beautiful%20Life%20poster%20rural%20revitalization%20warm%20village%20smiling%20people%20green%20fields&width=600&height=375&seq=video-cover-16&orientation=landscape',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Our%20Beautiful%20Life%20variety%20show%20wide%20poster%20rural%20village%20warm&width=1200&height=675&seq=video-cover-16-detail&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=Our%20Beautiful%20Life%20show%20poster%20thumbnail%20rural&width=200&height=200&seq=video-cover-16-thumb&orientation=squarish',
    description: '多位明星好友走进乡村，体验最质朴的乡村生活，用双手创造美好，收获真挚友谊。',
    content: '《我们的美好生活》是一档以乡村振兴为主题的综艺节目。节目邀请了来自不同领域的明星嘉宾，他们暂时告别城市的繁华，走进中国各地的美丽乡村。在这里，他们需要自己动手种菜、做饭、修缮房屋，体验最真实的乡村生活。通过与当地村民的互动交流，嘉宾们不仅收获了劳动的快乐，更感受到了中国乡村的巨大变化和蓬勃生机。',
    tags: ['综艺', '乡村', '生活', '治愈'],
    views: 7100000,
    date: '2026-07-24',
    rating: 8.1,
    platform: '蜜桃视频',
  },
];

export const features = [
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    description: '1080P超清画质，支持4K播放，给您影院级观影体验，不缓冲不卡顿',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速加载',
    description: '全球CDN加速节点，秒开视频无需等待，流畅观看每一帧精彩画面',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '手机、平板、电脑多端无缝切换，随时随地畅享精彩内容',
  },
  {
    icon: 'ri-thumb-up-line',
    title: '完全免费',
    description: '所有视频资源完全免费观看，无需会员，无需付费，真正零门槛',
  },
  {
    icon: 'ri-timer-line',
    title: '每日更新',
    description: '最新剧集每日准时更新，追剧无需等待，精彩内容第一时间送达',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '严格的内容审核机制，无广告弹窗干扰，绿色健康观影环境',
  },
];

export const testimonials = [
  {
    name: '小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20casual%20style%20friendly%20smile%20clean%20white%20background%20professional%20headshot&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '自从发现了芭乐视频，追剧再也不用到处找资源了！画质清晰，播放流畅，每天都有新剧更新，太方便了！',
    rating: 5,
  },
  {
    name: '小李',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%20natural%20smile%20modern%20style%20clean%20white%20background%20professional%20headshot&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '作为动漫爱好者，樱桃视频的分类做得特别好，找番剧很方便。而且完全不卡顿，看番体验一级棒！',
    rating: 5,
  },
  {
    name: '老张',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%20warm%20smile%20casual%20clean%20white%20background%20professional%20headshot&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '年纪大了就爱看纪录片，西瓜视频上的BBC纪录片资源真全。芭乐视频整合了那么多平台，一个网站就够了！',
    rating: 4,
  },
  {
    name: '小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20student%20portrait%20bright%20smile%20modern%20clean%20white%20background%20professional%20headshot&width=100&height=100&seq=avatar-04&orientation=squarish',
    content: '下课回家就打开芭乐视频刷短剧，每集十几分钟刚刚好。推荐给我室友后，全宿舍都在用！',
    rating: 5,
  },
];

export const faqs = [
  {
    question: '芭乐视频需要注册会员吗？',
    answer: '不需要！芭乐视频所有内容完全免费，无需注册会员即可观看全部视频。我们致力于为用户提供零门槛的观影体验。',
  },
  {
    question: '芭乐视频支持哪些设备观看？',
    answer: '芭乐视频支持手机、平板、电脑等主流设备。只要使用浏览器访问我们的网站，就能随时随地畅享精彩内容。',
  },
  {
    question: '视频播放卡顿怎么办？',
    answer: '芭乐视频采用全球CDN加速技术，正常情况下播放流畅不卡顿。如遇卡顿，建议检查您的网络连接，或尝试切换清晰度。',
  },
  {
    question: '新剧什么时候更新？',
    answer: '芭乐视频每日更新最新剧集和电影资源。热门剧集通常在播出后24小时内上线，让您追剧不落人后。',
  },
  {
    question: '芭乐视频上的资源来自哪里？',
    answer: '芭乐视频聚合了蜜桃视频、西瓜视频、樱桃视频等多个优质水果视频平台的资源，为您提供丰富多样的内容选择。',
  },
  {
    question: '如何找到我想看的视频？',
    answer: '您可以通过首页的分类导航浏览不同类别的视频，也可以在分类页面使用筛选功能快速找到感兴趣的内容。',
  },
];